document.addEventListener("DOMContentLoaded", function (event) {
    var el1 = $('#btn-apply-1');
    var el2 = $('#btn-apply-2 .btn');

    function isElementInViewport (el) {

        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    }

    function onVisibilityChange(el, el2, callback) {
        var isVisibleBtnTopOld;
        var isVisibleBtnBottomOld;
        if (isElementInViewport(el) || isElementInViewport(el2)) {
            $('.bottom-fixed-container').removeClass('visible');
        } else {
            $('.bottom-fixed-container').addClass('visible');
        }

        return function () {
            var isVisibleBtnTop = isElementInViewport(el);
            var isVisibleBtnBottom = isElementInViewport(el2);

            if (isVisibleBtnTop != isVisibleBtnTopOld) {
                isVisibleBtnTopOld = isVisibleBtnTop;
                if (typeof callback == 'function') {
                    callback();
                }
            }

            if (isVisibleBtnBottom != isVisibleBtnBottomOld) {
                isVisibleBtnBottomOld = isVisibleBtnBottom;
                if (typeof callback == 'function') {
                    callback();
                }
            }
        };
    }

    if (el1 || el2) {
        var handler = onVisibilityChange(el1, el2, function() {
            $('.bottom-fixed-container').toggleClass('visible');
        });

        $(window).on('DOMContentLoaded load resize scroll', handler);
    }
});



// WEBPACK FOOTER //
// ./static/js/modules/joinus.js